var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { createGroups } from './utils/order';
import { GroupN } from './groupN';
/**
 * The Group transform group data by x and y channels, and aggregate.
 */
export var Group = function Group() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$channels = options.channels,
    channels = _options$channels === void 0 ? ['x', 'y'] : _options$channels,
    rest = __rest(options, ["channels"]);
  var groupBy = function groupBy(I, mark) {
    return createGroups(channels, I, mark);
  };
  return GroupN(Object.assign(Object.assign({}, rest), {
    groupBy: groupBy
  }));
};
Group.props = {};